import {Routes, Route} from 'react-router-dom';
import NavBar from './components/navbar';
import Home from './pages/home';
import Channels from './pages/channels';
import Schedules from './pages/schedules';
import Multiviewer from './pages/multiviewer';
import StreamConfiguration from './pages/streamConfiguration';
import ServiceConfiguration from './pages/serviceConfiguration';
import Help from './pages/help';
import './styles/homeStyles.css';
import './App.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import ChannelLayout from './pages/channel';

function App() {
  return (
    <>
    <NavBar />
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/channels" element={<Channels />} />
        <Route path="/schedules" element={<Schedules />} />
        <Route path="/multiviewer" element={<Multiviewer />} />
        <Route path="/stream-configuration" element={<StreamConfiguration />} />
        <Route path="/help" element={<Help />} />
        <Route path="/channels/bravoEast" element={<ChannelLayout channel={"Bravo-East"}/>} />
        <Route path="/channels/bravoWest" element={<ChannelLayout channel={"Bravo-West"}/>} />
        <Route path="/channels/cnbc" element={<ChannelLayout channel={"CNBC"}/>} />
        <Route path="/channels/echannelEast" element={<ChannelLayout channel={"E-East"}/>} />
        <Route path="/channels/eChannelWest" element={<ChannelLayout channel={"E-West"}/>} />
        <Route path="/channels/golf" element={<ChannelLayout channel={"Golf"}/>} />
        <Route path="/channels/oxygenEast" element={<ChannelLayout channel={"Oxygen-East"}/>} />
        <Route path="/channels/oxygenWest" element={<ChannelLayout channel={"Oxygen-West"}/>} />
        <Route path="/channels/syfyEast" element={<ChannelLayout channel={"Syfy-East"}/>} />
        <Route path="/channels/syfyWest" element={<ChannelLayout channel={"Syfy-West"}/>} />
        <Route path="/channels/universoEast" element={<ChannelLayout channel={"Universo-East"}/>} />
        <Route path="/channels/universoWest" element={<ChannelLayout channel={"Universo-West"}/>} />
        <Route path="/channels/usaEast" element={<ChannelLayout channel={"USA-East"}/>} />
        <Route path="/channels/usaWest" element={<ChannelLayout channel={"USA-West"}/>} />
        <Route path="/channels/sny" element={<ChannelLayout channel={"SNY"}/>} />
        <Route path="/channels/wbts" element={<ChannelLayout channel={"WBTS"}/>} />
        <Route path="/channels/knbc" element={<ChannelLayout channel={"KNBC"}/>} />
        <Route path="/channels/knsd" element={<ChannelLayout channel={"KNSD"}/>} />
        <Route path="/channels/kntv" element={<ChannelLayout channel={"KNTV"}/>} />
        <Route path="/channels/kxas" element={<ChannelLayout channel={"KXAS"}/>} />
        <Route path="/channels/wcau" element={<ChannelLayout channel={"WCAU"}/>} />
        <Route path="/channels/wmaq" element={<ChannelLayout channel={"WMAQ"}/>} />
        <Route path="/channels/wnbc" element={<ChannelLayout channel={"WNBC"}/>} />
        <Route path="/channels/wrc" element={<ChannelLayout channel={"WRC"}/>} />
        <Route path="/channels/wtvj" element={<ChannelLayout channel={"WTVJ"}/>} />
        <Route path="/channels/wvit" element={<ChannelLayout channel={"WVIT"}/>} />
        <Route path="/channels/nbcsBoston" element={<ChannelLayout channel={"NBCS-Boston"}/>} />
        <Route path="/channels/nbcsPhilly" element={<ChannelLayout channel={"NBCS-Philly"}/>} />
        <Route path="/channels/nbcsBayArea" element={<ChannelLayout channel={"NBCS-BayArea"}/>} />
        <Route path="/channels/nbcsCalifornia" element={<ChannelLayout channel={"NBCS-California"}/>} />
        <Route path="/channels/nbcsChicago" element={<ChannelLayout channel={"NBCS-Chicago"}/>} />
      </Routes>
    </LocalizationProvider>
    </>
  );
}

export default App;
